import { render, staticRenderFns } from "./EditorView.vue?vue&type=template&id=7090e3fb"
import script from "./EditorView.vue?vue&type=script&lang=js"
export * from "./EditorView.vue?vue&type=script&lang=js"
import style0 from "./EditorView.vue?vue&type=style&index=0&id=7090e3fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports